import axios from 'axios';
import {LOCAL_STORAGE_ACCESS_TOKEN_KEY, REFRESH_PATH} from './authConstants';
import {refreshToken} from './auth';
import {logout} from './walletAxios';

const capitalAxiosClient = axios.create({
    baseURL: process.env.REACT_APP_CAPITAL_URL || '',
});

let refreshPromise = null;

let _onCapitalError = null;
export const setCapitalErrorHandler = (fn) => { _onCapitalError = fn; };

const extractMessage = (err) => {
    if (!err.response) return 'Network error — check your connection';
    const {status, data} = err.response;
    if (data?.message) return data.message;
    if (data?.error) return data.error;
    return `Server error (${status})`;
};

capitalAxiosClient.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (originalRequest?._retry || originalRequest?.url?.includes(REFRESH_PATH)) {
            return Promise.reject(error);
        }

        if (error.response?.status === 401) {
            originalRequest._retry = true;

            if (!refreshPromise) {
                refreshPromise = refreshToken().finally(() => {
                    refreshPromise = null;
                });
            }

            try {
                await refreshPromise;
                originalRequest.headers.Authorization = buildAuthorizationHeader();
                return capitalAxiosClient(originalRequest);
            } catch {
                logout();
                return Promise.reject(error);
            }
        }

        _onCapitalError?.(extractMessage(error));
        return Promise.reject(error);
    },
);

export const get = async (url) => request(url, {method: 'GET', headers: {}});

export const post = async (url, payload) =>
    request(url, {
        method: 'POST',
        data: JSON.stringify(payload),
        headers: {'Content-Type': 'application/json'},
    });

export const put = async (url, payload) =>
    request(url, {
        method: 'PUT',
        data: JSON.stringify(payload),
        headers: {'Content-Type': 'application/json'},
    });

export const del = async (url) => request(url, {method: 'DELETE', headers: {}});

const request = async (url, options) => {
    options.headers.Authorization = buildAuthorizationHeader();
    return capitalAxiosClient(url, options).then(r => r.data);
};

function buildAuthorizationHeader() {
    return `Bearer ${localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY)}`;
}
